import LazyLoad from "vanilla-lazyload";
import Masonry from "masonry-layout";
import Isotope from "isotope-layout";
const Flickity = require("flickity-fade");
import socialIcons from "social-icons";
import arRows from "ar-rows";
import hoverintent from "hoverintent";
import smoothscroll from "smoothscroll-polyfill";

smoothscroll.polyfill();

/* SETUP VARS */
let bw = document.body.scrollWidth;
let dpr = window.devicePixelRatio;
const body = document.querySelector("body");
const menuBtn = document.querySelector(".menuBtn");
let socialEl = document.querySelectorAll(".social");
let rowsEl = document.querySelectorAll(".ar-rows");
const nav = document.querySelector("nav");
const overlay = document.getElementById("overlay");
const overlayInner = overlay.querySelector(".inner");
const overlayCloser = overlay.querySelector(".closer");
let backgroundTriggers = document.querySelectorAll(".section.reveal");
let backgroundImages = document.querySelectorAll(".background-imgs .media");
let sections = document.querySelector(".sections");
let hoverContent = document.querySelectorAll(".hover-content");
let background = document.querySelector(".background-imgs");
let sidebar = document.querySelector(".left");
let mobileOpener = document.querySelector(".mobile-only .mobile-caret");
let mobileOnly = document.querySelector(".mobile-only");

document.addEventListener("DOMContentLoaded", function () {
  /* ***************************************** */
  /* INITIALIZATION ON PAGE LOAD */
  /* ***************************************** */

  body.classList.remove("preload");

  // homepage loading sequence
  if (body.classList.contains("homepage")) {
    setTimeout(function () {
      body.classList.remove("loading");
    }, 1500);
    let agboVerseBtn = document.querySelector(".topright");
    if (typeof agboVerseBtn != "undefined" && agboVerseBtn != null) {
      setTimeout(function () {
        agboVerseBtn.classList.remove("hide");
      }, 2000);
    }
  }

  // check for any social icons
  if (typeof socialIcons != "undefined") {
    socialIcons(socialEl);
  }

  // init AR Rows type layout
  if (typeof arRows != "undefined") {
    arRows(rowsEl);
  }

  // any cols from text editor need to be wrapped in cols class
  let textCols = document.querySelectorAll(".text-block");
  for (var i = 0; i < textCols.length; i++) {
    wrapCols(textCols[i]);
  }

  /* HANDLE CELLS THAT REQUIRE RATIO SIZING */
  let ratioCells = document.getElementsByClassName("ratioSize");
  for (let i = 0; i < ratioCells.length; i++) {
    ratioSize(ratioCells[i]);
  }

  //initialize lazyload - sitewide for image
  function lazyLoadInit() {
    const lazyLoad = new LazyLoad({
      elements_selector: ".loadmeview",
      callback_enter: loadImage,
    });
  }

  lazyLoadInit();

  // countdown for film fest
  let countdownEl = document.getElementById("countdown");
  if (typeof countdownEl != "undefined" && countdownEl != null) {
    const finaleDate = new Date("April 16, 2021 19:30:00 PST").getTime();

    const timer = () => {
      const now = new Date().getTime();
      let diff = finaleDate - now;
      if (diff < 0) {
        document.querySelector(".alert").style.display = "block";
        document.querySelector(".container").style.display = "none";
      }

      let days = Math.floor(diff / (1000 * 60 * 60 * 24));
      let hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      let minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((diff % (1000 * 60)) / 1000);

      days <= 99 ? (days = `${days}`) : days;
      days <= 9 ? (days = `${days}`) : days;
      hours <= 9 ? (hours = `${hours}`) : hours;
      minutes <= 9 ? (minutes = `${minutes}`) : minutes;
      seconds <= 9 ? (seconds = `0${seconds}`) : seconds;

      document.querySelector("#days").textContent = days;
      document.querySelector("#hours").textContent = hours;
      document.querySelector("#minutes").textContent = minutes;
      document.querySelector("#seconds").textContent = seconds;
    };
    timer();
    setInterval(timer, 1000);
  }

  let startFilter = body.getAttribute("data-slug");
  if (startFilter == null) {
    startFilter = "all";
  }
  const isoGrid = document.getElementById("isogrid");
  let iso;
  if (typeof isoGrid != "undefined" && isoGrid != null) {
    // add pageOn to work nav based on the startFilter
    /*
    nav
      .querySelector("a[data-tag='" + startFilter + "']")
      .classList.add("pageOn");
    */

    iso = new Isotope(isoGrid, {
      itemSelector: ".cell",
      layoutMode: "fitRows",
      fitRows: {
        gutter: 0,
      },
      filter: "." + startFilter,
      getSortData: {
        name: "[data-name]",
      },
    });
  }

  function isoFilter(filterClass) {
    window.scroll(0, 0);
    iso.arrange({ filter: "." + filterClass });
  }

  function isoSort(theSort, theDir) {
    let ascend = true;
    if (theDir === "desc") {
      ascend = false;
    }
    iso.arrange({
      sortBy: theSort,
      sortAscending: ascend,
    });
  }

  // initialize masonry
  const masongrids = document.querySelectorAll(".masongrid");

  masongrids.forEach((masongrid) => {
    //injecting bottom margin into masonry cell
    let gutterWidth = masongrid.querySelector(".gutter-sizer").scrollWidth;
    let cells = masongrid.getElementsByClassName("cell");
    for (var i = 0; i < cells.length; i++) {
      cells[i].style.marginBottom = gutterWidth + "px";
    }

    const msnry = new Masonry(masongrid, {
      itemSelector: ".cell",
      columnWidth: ".grid-sizer",
      gutter: ".gutter-sizer",
    });
    msnry.layout();

    function onLayoutComplete() {
      // run lazyload after masonry has run
      const masonLoad = new LazyLoad({
        elements_selector: ".masonlazy",
      });
    }
    msnry.on("layoutComplete", onLayoutComplete);
  });

  //initialize flickity for slideshows

  let slideshowEl = document.querySelector(".slideshow");

  if (typeof slideshowEl != "undefined" && slideshowEl != null) {
    let flkty = new Flickity(slideshowEl, {
      // options
      fade: false,
      cellAlign: "left",
      cellSelector: ".cell",
      wrapAround: true,
    });
  }

  /* HANDLE IMAGES THAT REQUIRE RESIZE IMAGE FUNCTION */
  let resizeImageCells = document.getElementsByClassName("resize-image");
  for (let i = 0; i < resizeImageCells.length; i++) {
    resizeImage(resizeImageCells[i]);
  }

  /* ***************************************** */
  /* FUNCTIONS */
  /* ***************************************** */

  function loadImage(image) {
    let img = image.getAttribute("data-img"),
      newW = image.classList.contains("bg-loadme")
        ? image.offsetWidth * dpr
        : image.parentNode.offsetWidth * dpr,
      fullpath = "",
      imgpath = "";

    if (!image.classList.contains("gif")) {
      if (newW <= 500) {
        imgpath = "/images/pics/500/" + img;
      } else if (newW > 500 && newW <= 750) {
        imgpath = "/images/pics/750/" + img;
      } else if (newW > 750 && newW <= 1000) {
        imgpath = "/images/pics/1000/" + img;
      } else if (newW > 1000 && newW <= 1536) {
        imgpath = "/images/pics/1536/" + img;
      } else if (newW > 1536 && newW <= 1920) {
        imgpath = "/images/pics/1920/" + img;
      } else {
        imgpath = "/images/pics/" + img;
      }
    } else {
      // load jpg as placeholder, when gif loaded swap
      imgpath = "/images/pics/500/" + img;
      fullpath = "/images/pics/" + img;

      var fullimg = new Image();
      fullimg.onload = function () {
        var fullImgSrc = fullimg.getAttribute("src");
        image.src = fullImgSrc;
        //$('.photo[data-src="' + img + '"]').attr("src", fullImgSrc);
      };
      fullimg.src = fullpath;
    }

    if (image.classList.contains("bg-loadme")) {
      $("<img/>")
        .attr("src", imgpath)
        .on("load", function () {
          $(this).remove();
          image
            .css("background-image", "url(" + imgpath + ")")
            .addClass("loaded");
        });
    } else {
      let newimage = new Image();
      newimage.onload = function () {
        image.src = imgpath;
        //image.classList.add("loaded");
      };
      newimage.src = imgpath;
    }
  }

  function wrapCols(el) {
    let elContainer = document.createElement("div");
    Array.prototype.forEach.call(el.querySelectorAll(".col"), function (c) {
      elContainer.appendChild(c);
    });
    elContainer.classList.add("cols");
    el.appendChild(elContainer);
  }

  // AJAX GET
  function getAjax(url, success) {
    var xhr = window.XMLHttpRequest
      ? new XMLHttpRequest()
      : new ActiveXObject("Microsoft.XMLHTTP");
    xhr.open("GET", url);
    xhr.onreadystatechange = function () {
      if (xhr.readyState > 3 && xhr.status == 200) success(xhr.responseText);
    };
    xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    xhr.send();
    return xhr;
  }

  function removeSelectedCell() {
    let selectedCell = document.querySelector(".cell.selected");
    if (typeof selectedCell != "undefined" && selectedCell != null) {
      selectedCell.classList.remove("selected");
    }
  }

  function closeOverlay() {
    removeSelectedCell();
    overlay.classList.remove("on");
    body.classList.remove("overlayOn");
    remove_hash_from_url();
  }

  function ratioSize(el) {
    let width = el.scrollWidth,
      ratio = el.getAttribute("data-ratio"),
      height = Math.floor(width * ratio);

    el.style.height = height + "px";
  }

  function resizeImage(el) {
    let photo = el.getElementsByClassName("photo"),
      parentWidth = Math.floor(el.scrollWidth),
      parentHeight = Math.floor(el.scrollHeight),
      parentRatio = parentHeight / parentWidth,
      photoRatio = photo[0].getAttribute("data-aspect-ratio");

    if (photoRatio >= parentRatio) {
      photo[0].classList.add("size-width");
      photo[0].classList.remove("size-height");
    } else {
      photo[0].classList.add("size-height");
      photo[0].classList.remove("size-width");
    }
  }

  function resizeFrame(el) {
    let parent = el.closest(".vidhold"),
      pw = parent.offsetWidth,
      ph = parent.offsetHeight,
      pr = ph / pw,
      orgW = el.getAttribute("width"),
      orgH = el.getAttribute("height"),
      r = orgH / orgW;

    if (r <= pr) {
      var nw = pw;
      var nh = nw * r;
    } else {
      var nw = ph / r,
        nh = ph;
    }

    el.setAttribute("width", nw);
    el.setAttribute("height", nh);
  }

  function anchorScroll(anchor) {
    // scroll to selection
    let targetCell = document.querySelector(
      '.anchor[data-id="' + anchor + '"]'
    );

    let offsetPosition = targetCell.offsetTop;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  }

  const mouseenterEvent = new Event("mouseenter");

  function showBio(el) {
    let id = el.getAttribute("data-id");
    let slug = el.getAttribute("data-slug");
    let href = el.getAttribute("href");
    history.pushState("", "", href);

    // close mobile menu and any open filters
    body.classList.remove("menuOn");
    document.querySelector("article.inner .left").classList.remove("on");
    document.querySelector("header .mobile-only").classList.remove("off");

    // turn off any page on states
    for (let i = 0; i < bioLinksLength; ++i) {
      bioLinks[i].classList.remove("pageOn");
    }

    // keep the selected page on
    el.classList.add("pageOn");

    // scroll to selection
    let bioCell = document.querySelector('.cell[data-id="' + id + '"]');

    let offsetPosition = bioCell.offsetTop;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });

    bioCell.querySelector(".overlayLink").click();

    /*

    bioCell.dispatchEvent(mouseenterEvent);
    bioCell.classList.add("active");

    */

    /*
    bioCell.classList.add("active");

    // turn off any page on states except the active one
    setTimeout(function () {
      for (let i = 0; i < bioCellsLength; ++i) {
        let bioId = bioCells[i].getAttribute("data-id");
        if (bioId != id) {
          bioCells[i].classList.remove("active");
        }
      }
    }, 500);
    */
  }

  /* HANDLE WINDOW RESIZE */

  function reportWindowSize() {
    /* HANDLE CELLS THAT REQUIRE RATIO SIZING */
    let ratioCells = document.getElementsByClassName("ratioSize");
    for (let i = 0; i < ratioCells.length; i++) {
      ratioSize(ratioCells[i]);
    }

    /* HANDLE IMAGES THAT REQUIRE RESIZE IMAGE FUNCTION */
    let resizeImageCells = document.getElementsByClassName("resize-image");
    for (let i = 0; i < resizeImageCells.length; i++) {
      resizeImage(resizeImageCells[i]);
    }

    // handle resizing of AR Rows
    let arRowsCell = document.querySelectorAll(".ar-rows .row .cell");
    for (let i = 0; i < arRowsCell.length; ++i) {
      var _this = arRowsCell[i],
        container = _this.closest(".ar-rows"),
        rowsMargin = container.getAttribute("data-margin"),
        percW = _this.getAttribute("data-percW"),
        percH = _this.getAttribute("data-percH"),
        ratio = _this.getAttribute("data-ratio"),
        num = _this.getAttribute("data-numImages"),
        containerWidth = container.offsetWidth - rowsMargin * (num - 1);

      _this.style.width = containerWidth * percW + "px";
      let cellImg = _this.querySelector("img");
      cellImg.style.height = ratio * (containerWidth * percW) + "px";
    }
  }

  window.addEventListener("resize", reportWindowSize);

  /* ***************************************** */
  /* EVENTS */
  /* ***************************************** */

  /* ABOUT PAGE CELL OVER, GRAYS OUT ALL EXCEPT ACTIVE */

  let grayOutLinks = document.querySelectorAll(".gray-out .cell");
  let grayOutLinksLength = grayOutLinks.length;

  let grayGrid = document.querySelector(".gray-out");

  if (typeof grayGrid != "undefined" && grayGrid != null) {
    grayGrid.addEventListener("mouseleave", resetCells);
  }

  function grayOutCells(grid) {
    let cells = grid.querySelectorAll(".cell");
    for (let i = 0; i < cells.length; ++i) {
      let cell = cells[i];
      if (
        cell.classList.contains("active") ||
        cell.classList.contains("primary")
      ) {
        //cell.classList.add("gray");
      } else {
        cell.classList.add("gray");
      }
    }
  }

  function resetCells() {
    for (let i = 0; i < grayOutLinksLength; ++i) {
      let cell = grayOutLinks[i];
      cell.classList.remove("active", "gray");
    }
  }

  for (let i = 0; i < grayOutLinksLength; ++i) {
    grayOutLinks[i].addEventListener("mouseenter", function () {
      resetCells();
      let cell = this;
      if (cell.classList.contains("primary")) {
        return;
      }
      cell.classList.add("active");
      let gridEl = this.parentNode;
      grayOutCells(gridEl);
    });
  }

  /* DETAIL PAGE SLIDESHOW IMAGE LINK */

  function remove_hash_from_url() {
    var uri = window.location.toString();

    if (uri.indexOf("#") > 0) {
      var clean_uri = uri.substring(0, uri.indexOf("#"));

      window.history.replaceState({}, document.title, clean_uri);
    }
  }

  let overlayLinks = document.querySelectorAll("a.overlayLink");
  let overlayLinksLength = overlayLinks.length;

  function loadLightbox(cell, id, slug) {
    getAjax("/getItem.php?id=" + id, function (data) {
      // load data into overlay
      cell.classList.add("selected");
      overlayInner.innerHTML = data;
      lazyLoadInit();
      body.classList.add("overlayOn");
      overlay.classList.add("on");
      window.location.hash = slug;
    });
  }

  for (let i = 0; i < overlayLinksLength; ++i) {
    overlayLinks[i].addEventListener("click", function (e) {
      e.preventDefault();
      let id = this.getAttribute("data-id");
      let slug = this.getAttribute("data-slug");
      let cell = this.closest(".cell");
      // ajax call to get page text
      loadLightbox(cell, id, slug);
    });
  }

  /* LEFT / RIGHT ARROWS IN LIGHTBOX */
  let overlayArrowNext = overlay.querySelector(".arrow.next");
  let overlayArrowPrev = overlay.querySelector(".arrow.prev");

  overlayArrowNext.addEventListener("click", function (e) {
    e.preventDefault();
    let selectedCell = document.querySelector(".cell.selected");
    let nextCell = selectedCell.nextElementSibling;
    if (typeof nextCell == "undefined" || nextCell == null) {
      // if next comes up blank, we are at end of list, target first cell
      nextCell = document.querySelector(".right .cell.lightbox");
    }
    let nextLink = nextCell.querySelector("a");
    let nextId = nextLink.getAttribute("data-id");
    removeSelectedCell();
    loadLightbox(nextCell, nextId);
  });

  overlayArrowPrev.addEventListener("click", function (e) {
    e.preventDefault();
    let selectedCell = document.querySelector(".cell.selected");
    let nextCell = selectedCell.previousElementSibling;
    if (
      typeof nextCell == "undefined" ||
      nextCell == null ||
      !nextCell.classList.contains("lightbox")
    ) {
      // if next comes up blank, we are at end of list, target last cell
      nextCell = document.querySelector(".right .cell.lightbox.last");
    }
    let nextLink = nextCell.querySelector("a");
    let nextId = nextLink.getAttribute("data-id");
    removeSelectedCell();
    loadLightbox(nextCell, nextId);
  });

  document.addEventListener("keydown", logKey);

  function logKey(e) {
    if (body.classList.contains("overlayOn")) {
      if (e.code === "ArrowRight") {
        simulateClick(overlayArrowNext);
      }
      if (e.code === "ArrowLeft") {
        simulateClick(overlayArrowPrev);
      }
      if (e.code === "Escape") {
        simulateClick(overlayCloser);
      }
    }
  }

  /* ADDITION OF ISOTOPE GRID FOR PRODUCTIONS PAGE */

  let filterLink = document.querySelectorAll("a.filter");
  let filterLinkLength = filterLink.length;

  let filterCells = document.querySelectorAll(".croppedgrid .cell");
  let filterCellsLength = filterCells.length;

  let filterSubs = document.querySelectorAll(".filter ul.subs");
  let filterSubsLength = filterSubs.length;

  let sortLink = document.querySelectorAll("a.sorter");
  let sortLinkLength = sortLink.length;

  // on film detail page, check for hash value and update close link with that value
  let filmDetail = document.querySelector(".projectpage");
  if (typeof filmDetail != "undefined" && filmDetail != null) {
    let selectedItemID = body.getAttribute("data-id");

    if (window.location.hash) {
      var theHash = window.location.hash;
      var hashFilter = theHash.replace("#", "");

      let closeLink = filmDetail.querySelector(".closeLink");
      let currentLink = closeLink.getAttribute("data-link");
      let newLink = currentLink + "#" + hashFilter;
      closeLink.setAttribute("href", newLink);

      getAjax(
        "/ajaxPager.php?slug=" + hashFilter + "&itemID=" + selectedItemID,
        function (data) {
          let response = JSON.parse(data);
          document
            .querySelector(".nextProject")
            .setAttribute("href", response.nextLink + "#" + hashFilter);
          document
            .querySelector(".prevProject")
            .setAttribute("href", response.prevLink + "#" + hashFilter);
        }
      );
    } else {
      getAjax(
        "/ajaxPager.php?slug=all&itemID=" + selectedItemID,
        function (data) {
          let response = JSON.parse(data);
          document
            .querySelector(".nextProject")
            .setAttribute("href", response.nextLink + "#" + hashFilter);
          document
            .querySelector(".prevProject")
            .setAttribute("href", response.prevLink + "#" + hashFilter);
        }
      );
    }
  }

  // check for hash value on filter page load
  let isoGridEl = document.getElementById("isogrid");
  if (typeof isoGridEl != "undefined" && isoGridEl != null) {
    if (window.location.hash) {
      var theHash = window.location.hash;
      var hashFilter = theHash.replace("#", "");

      // update the cell links with the hash value, need this for "X" from film detail page
      for (let i = 0; i < filterCellsLength; ++i) {
        let filterCell = filterCells[i];
        let filterLink = filterCell.querySelector("a");
        let currentLink = filterLink.getAttribute("data-link");
        let newLink = currentLink + "#" + hashFilter;
        filterLink.setAttribute("href", newLink);
      }

      // remove pageOn class from all filters, add to matching hash

      removeFilterState();
      addFilterState(hashFilter);
      isoFilter(hashFilter);

      var hashEl = document.querySelector(
        "a.filter[data-filter='" + hashFilter + "']"
      );

      // addition of sub sub categories for filters
      if (hashEl.classList.contains("parent")) {
        var filterSub = hashEl.nextElementSibling;
        filterSub.classList.add("on");
      }
    }
  }

  // click event for sorting
  for (let i = 0; i < sortLinkLength; ++i) {
    sortLink[i].addEventListener("click", function (e) {
      e.preventDefault();
      let sort = this.getAttribute("data-sort");
      let dir = this.getAttribute("data-dir");
      removeSortState();
      addSortState(this);
      isoSort(sort, dir);
    });
  }

  // click event for filters
  for (let i = 0; i < filterLinkLength; ++i) {
    filterLink[i].addEventListener("click", function (e) {
      e.preventDefault();
      let filter = this.getAttribute("data-filter");
      if (filter !== "all") {
        window.location.hash = filter;
      } else {
        history.replaceState(null, null, " ");
      }

      // update the cell links with the hash value, need this for "X" from film detail page
      for (let i = 0; i < filterCellsLength; ++i) {
        let filterCell = filterCells[i];
        let filterLink = filterCell.querySelector("a");
        let currentLink = filterLink.getAttribute("data-link");
        let newLink = currentLink + "#" + filter;
        filterLink.setAttribute("href", newLink);
      }

      removeFilterState();
      if (!this.classList.contains("child")) {
        removeFilterSubState();
      }
      addFilterState(filter);
      isoFilter(filter);

      // close mobile menu and any open filters
      body.classList.remove("menuOn");
      document.querySelector("article.inner .left").classList.remove("on");
      document.querySelector("header .mobile-only").classList.remove("off");

      // addition of sub sub categories for filters
      if (this.classList.contains("parent")) {
        var filterSub = this.nextElementSibling;
        filterSub.classList.add("on");
      }
    });
  }

  function addFilterState(filter) {
    document
      .querySelector("a.filter[data-filter='" + filter + "']")
      .classList.add("pageOn");
  }

  function removeFilterState() {
    for (let i = 0; i < filterLinkLength; ++i) {
      filterLink[i].classList.remove("pageOn");
    }
  }

  function removeFilterSubState() {
    for (let x = 0; x < filterSubsLength; ++x) {
      filterSubs[x].classList.remove("on");
    }
  }

  function addSortState(el) {
    el.classList.add("pageOn");
  }

  function removeSortState() {
    for (let i = 0; i < sortLinkLength; ++i) {
      sortLink[i].classList.remove("pageOn");
    }
  }

  function closeAllNavMenus() {
    for (let i = 0; i < navSubMenusLength; ++i) {
      navSubMenus[i].style.height = "0px";
    }
  }

  function showNavMenu(el) {
    let targetMenu = el.querySelector("ul.subs");
    let activeHeight = 0;
    let targetLinks = targetMenu.querySelectorAll("li");
    let targetLinksLength = targetLinks.length;
    for (let i = 0; i < targetLinksLength; ++i) {
      let linkHeight = targetLinks[i].offsetHeight;
      activeHeight += linkHeight + 10;
    }

    // close any open menus
    closeAllNavMenus();
    // apply active height to active target
    targetMenu.style.height = activeHeight + "px";
  }

  // menu subs hover state

  let navSubTriggers = nav.querySelectorAll("li.hassubs");
  let navSubTriggersLength = navSubTriggers.length;
  let navSubMenus = nav.querySelectorAll("ul.subs");
  let navSubMenusLength = navSubMenus.length;

  if (bw > 1023) {
    for (let i = 0; i < navSubTriggersLength; ++i) {
      hoverintent(
        navSubTriggers[i],
        function () {
          showNavMenu(this);
        },
        function () {}
      );
    }
  }

  /*
  else {
    for (let i = 0; i < navSubTriggersLength; ++i) {
      navSubTriggers[i].addEventListener(
        "click",

        function (event) {
          event.preventDefault(), showNavMenu(this);

          this.classList.add("active");
        },
        true
      );
    }
    let activeNavItems = nav.querySelectorAll("li.active");
    let activeNavItemsLength = activeNavItems.length;

    for (let i = 0; i < activeNavItemsLength; i++) {
      activeNavItems[i].addEventListener(
        "click",

        function (event) {
          event.preventDefault(), console.log(this);
          closeAllNavMenus();
        },
        true
      );
    }
  }

  */

  // generic anchor links with "anchor" class

  let anchorLinks = document.querySelectorAll("a.anchorlink");
  let anchorLinksLength = anchorLinks.length;

  for (let i = 0; i < anchorLinksLength; ++i) {
    let anchorLink = anchorLinks[i];
    anchorLink.addEventListener("click", function (e) {
      e.preventDefault();
      let anchor = this.getAttribute("data-id");
      anchorScroll(anchor);
    });
  }

  // about page bio links
  let bioLinks = document.querySelectorAll(".bioLink");
  let bioLinksLength = bioLinks.length;

  let bioCells = document.querySelectorAll(".team .cell");
  let bioCellsLength = bioCells.length;

  // about page bio load
  if (window.location.hash && body.classList.contains("teampage")) {
    let theHash = window.location.hash;
    let cleanHash = theHash.replace("#", "");
    let bioCell = document.querySelector(
      '.team .left ul li a[data-slug="' + cleanHash + '"]'
    );

    showBio(bioCell);
  }

  for (let i = 0; i < bioLinksLength; ++i) {
    let bioLink = bioLinks[i];
    bioLink.addEventListener("click", function (e) {
      e.preventDefault();
      let el = this;
      showBio(el);
    });
  }

  function showCommunity(el) {
    let slug = el.getAttribute("data-slug");
    let elParent = el.parentNode;

    window.location.hash = slug;

    // turn off any page on states
    for (let i = 0; i < communityLinksLength; ++i) {
      communityLinks[i].classList.remove("pageOn");
      let linkParent = communityLinks[i].parentNode;
      let linkSub = linkParent.querySelector("ul.subs");
      if (typeof linkSub != "undefined" && linkSub != null) {
        linkSub.classList.remove("pageOn");
      }
    }

    // keep the selected page on
    el.classList.add("pageOn");

    // if this section has sub pages, show them
    if (el.classList.contains("withSubs")) {
      elParent.querySelector("ul.subs").classList.add("pageOn");
    }

    // scroll to selection
    let communityCell = document.querySelector(".community .cell." + slug);

    let offsetPosition = communityCell.offsetTop;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });

    let communityCells = document.querySelectorAll(".community .cell");
    let communityCellsLength = communityCells.length;

    if (slug === "all") {
      for (let i = 0; i < communityCellsLength; ++i) {
        let cell = communityCells[i];
        cell.classList.remove("active", "gray");
      }
    } else {
      // add active state to all cells that match slug

      for (let i = 0; i < communityCellsLength; ++i) {
        let cell = communityCells[i];
        if (cell.classList.contains(slug)) {
          communityCells[i].classList.remove("gray");
          communityCells[i].classList.add("active");
        } else {
          communityCells[i].classList.remove("active");
          communityCells[i].classList.add("gray");
        }
      }
    }
  }

  // community page nav links
  let communityLinks = document.querySelectorAll(".communityLink");
  let communityLinksLength = communityLinks.length;

  // community page bio load
  if (window.location.hash && body.classList.contains("communitypage")) {
    let theHash = window.location.hash;
    let cleanHash = theHash.replace("#", "");
    let communityCell = document.querySelector(
      '.community .left ul li a[data-slug="' + cleanHash + '"]'
    );

    showCommunity(communityCell);
  }

  for (let i = 0; i < communityLinksLength; ++i) {
    let communityLink = communityLinks[i];
    communityLink.addEventListener("click", function (e) {
      e.preventDefault();
      let el = this;
      showCommunity(el);
    });
  }

  //hamburger menu toggle
  menuBtn.addEventListener(
    "click",
    function (event) {
      event.preventDefault(), document.body.classList.toggle("menuOn");
    },
    true
  );

  // close overlay
  overlayCloser.addEventListener(
    "click",
    function (event) {
      event.preventDefault();
      closeOverlay();
    },
    true
  );

  //open/close sidebar on mobile
  if (typeof mobileOpener !== "undefined" && mobileOpener !== null) {
    mobileOpener.addEventListener(
      "click",
      function (event) {
        event.preventDefault(), sidebar.classList.toggle("on");
        mobileOnly.classList.add("off");
      },
      true
    );
  }

  function showSectionClick(section) {
    let sectionId = section.getAttribute("data-id");

    // remove active class from all sections
    for (let b = 0; b < backgroundTriggers.length; b++) {
      backgroundTriggers[i].classList.remove("active");
    }

    // remove active class from any bg images
    for (let i = 0; i < backgroundTriggers.length; i++) {
      backgroundTriggers[i].classList.remove("active");
    }

    for (let i = 0; i < backgroundImages.length; i++) {
      backgroundImages[i].classList.remove("active");
    }

    let activeImg = document.querySelector(
      '.background-imgs .media[data-id="' + sectionId + '"]'
    );
    activeImg.classList.add("active");
    section.classList.add("active");
    background.classList.add("on");
  }

  function showSection() {
    let sectionId = this.getAttribute("data-id");

    // remove active class from any bg images
    for (let i = 0; i < backgroundTriggers.length; i++) {
      backgroundTriggers[i].classList.remove("active");
    }

    for (let i = 0; i < backgroundImages.length; i++) {
      backgroundImages[i].classList.remove("active");
    }

    let activeImg = document.querySelector(
      '.background-imgs .media[data-id="' + sectionId + '"]'
    );
    activeImg.classList.add("active");
    this.classList.add("active");
    background.classList.add("on");
  }

  function hideSection() {
    this.classList.remove("active");
    background.classList.remove("on");
  }

  function hideLogo() {
    body.classList.add("section_on");
  }

  function showLogo() {
    body.classList.remove("section_on");
  }

  // if user mouse is anywhere in bottom section don't show AGBO logo
  if (typeof sections != "undefined" && sections != null) {
    if (bw > 1023) {
      sections.addEventListener("mouseenter", hideLogo);
      sections.addEventListener("mouseleave", showLogo);
    }
  }

  //show bkgd img on homepage
  for (let i = 0; i < backgroundTriggers.length; i++) {
    if (bw > 1023) {
      backgroundTriggers[i].addEventListener("mouseenter", showSection);
      backgroundTriggers[i].addEventListener("mouseleave", hideSection);
    } else {
      backgroundTriggers[i].addEventListener("click", function (e) {
        let section = this;
        if (!this.classList.contains("active")) {
          showSectionClick(section);
          hideLogo();
        }
      });
    }
  }

  /**
   * Simulate a click event.
   * @public
   * @param {Element} elem  the element to simulate a click on
   */
  var simulateClick = function (elem) {
    // Create our event (with options)
    var evt = new MouseEvent("click", {
      bubbles: true,
      cancelable: true,
      view: window,
    });
    // If cancelled, don't dispatch our event
    var canceled = !elem.dispatchEvent(evt);
  };

  // example link for AJAX request
  const ajaxLink = document.querySelector("a.ajax");
  if (typeof ajaxLink != "undefined" && ajaxLink != null) {
    ajaxLink.addEventListener(
      "click",
      function (event) {
        event.preventDefault();
        // caption slug for URL
        let linkSlug = this.getAttribute("data-slug");
        window.location.hash = linkSlug;

        // ajax call to get page text
        getAjax("/getTextpage.php?slug=" + linkSlug, function (data) {
          // load data into overlay
          overlayInner.innerHTML = data;
          overlay.classList.add("on");
          // return side nav to "off" state
          nav.classList.remove("open");
          // add blur class to body
          body.classList.add("blur");
        });
      },
      true
    );
  }
});
